import { useAuth } from "../../../usercontext";
import GlobalGradeInMonth from "../../pages/common/globalgradeinmonth";
// import PageNotes from "../../pages/common/pagenotes";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentGradesInMonthEdit() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent911 = profile?.role === "Student911"
  return (
		<>
			{!isStudent911 && <STopMenu slug={slug} activeMenu="CurrentGrades" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="CurrentGrades" />}
      <PageNotes type={'Student'} studentId={slug} />
			<GlobalGradeInMonth studentId={profile.id} ClassId={profile.class} isStudent={true} />
			{/* <PageNotes
        type={"Student"}
        pageName={"CurrentGrades"}
        studentId={profile.id}
      /> */}
		</>
	)
}
